import { Box, Heading, HStack } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface PageContainerProps {
  title: string;
  breadcrumbs?: BreadcrumbItem[];
  actions?: ReactNode;
  children: ReactNode;
}

export function PageContainer({ title, breadcrumbs: _breadcrumbs, actions, children }: PageContainerProps) {
  return (
    <Box p={6}>
      <HStack justify="space-between" mb={6}>
        <Heading size="lg" color="text-primary">{title}</Heading>
        {actions}
      </HStack>
      {children}
    </Box>
  );
}
